import { defineStore } from "pinia";
import Services from '@/services/previousEmploymentServices'
import { mapPreviousEmployment } from '@/helpers/mapFuncs'

export const usePreviousEmploymentStore = defineStore("previousEmployment", {

state:()=>({
    previousEmployment: {},
    previousEmployments: [],
}),
getters : {
    getPreviousEmployment() {
        return mapPreviousEmployment(this.previousEmployment)
    },
    getPreviousEmployments() {
        return this.previousEmployments.map(mapPreviousEmployment)
    }
},
actions : {
    /** Start Sets */
    setPreviousEmployment(previousEmployment) {
        this.previousEmployment = previousEmployment
    },
    setPreviousEmployments(previousEmployments) {
        this.previousEmployments = previousEmployments
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setPreviousEmployment(response.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setPreviousEmployment(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setPreviousEmployments(response.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.previousEmployments.push(response.data)
            return mapPreviousEmployment(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.previousEmployments[this.previousEmployments.findIndex((x)=>x.id == id)] = response.data
            return mapPreviousEmployment(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.previousEmployments = this.previousEmployments.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});